export default "__VITE_ASSET__9xvng2fe__"